import { PartOfDay } from '../types/time-off-part-of-day';

export const PART_OF_DAY_LABEL_KEY: Record<PartOfDay, string> = {
  [PartOfDay.FullDay]: 'partOfDay.fullDay',
  [PartOfDay.FirstHalf]: 'partOfDay.firstHalf',
  [PartOfDay.SecondHalf]: 'partOfDay.secondHalf',
  [PartOfDay.FirstQuarter]: 'partOfDay.firstQuarter',
  [PartOfDay.SecondQuarter]: 'partOfDay.secondQuarter',
  [PartOfDay.ThirdQuarter]: 'partOfDay.thirdQuarter',
  [PartOfDay.FourthQuarter]: 'partOfDay.fourthQuarter',
  [PartOfDay.Custom]: 'partOfDay.custom',
};
